import { useQuery } from 'convex/react';

import { api } from '../../convex/_generated/api';

/**
 * Experimenter-controlled values the participant UI needs: upload caps,
 * the site-wide notice, whether sign-up is open, and whether checkpoints
 * are auto-approved. Reactive — changes in the panel apply instantly.
 *
 * Returns sensible defaults while loading so callers never branch on
 * `undefined`.
 */
export interface PublicSettings {
  maintenanceMessage: string;
  signupEnabled: boolean;
  maxSketchesPerProject: number;
  maxSketchMb: number;
  sessionMode: string;
  autoApproveCheckpoints: boolean;
  loaded: boolean;
}

const DEFAULTS: PublicSettings = {
  maintenanceMessage: '',
  signupEnabled: true,
  maxSketchesPerProject: 5,
  maxSketchMb: 10,
  sessionMode: 'takeover',
  autoApproveCheckpoints: false,
  loaded: false,
};

export function usePublicSettings(): PublicSettings {
  const result = useQuery(api.settings.getPublic, {});
  if (result === undefined) return DEFAULTS;
  return { ...result, loaded: true };
}
